/* eslint-disable max-len */
import React from 'react';

function PurpleAngleLongLeftSVG(props) {
  return (
    <svg width={1181} height={349} viewBox='0 0 1181 349' fill='none' {...props}>
      <path
        transform='rotate(170.518 1180.01 84.03)'
        fill='url(#prefix__paint0_linear-04)'
        d='M1180.01 84.031h1607.78v85H1180.01z'
      />
      <defs>
        <linearGradient
          id='prefix__paint0_linear-04'
          x1={2786.25}
          y1={127.445}
          x2={1530.88}
          y2={161.022}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#8298FC' />
          <stop offset={1} stopColor='#8298FC' stopOpacity={0} />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default PurpleAngleLongLeftSVG;
